import { Box } from '@mui/material'
import clsx from 'clsx'
import useMoveKeyboardJoystick, { MovementHanlder } from 'hooks/useMoveKeyboardJoystick'
import { ReactComponent as JoysticDirection } from 'images/joystickDirection.svg'
import { useState } from 'react'
import { Joystick } from 'react-joystick-component'
import { IJoystickProps, IJoystickUpdateEvent } from 'react-joystick-component/build/lib/Joystick'

import style from './RobotJoystick.module.css'

interface Props extends IJoystickProps {
  vertical?: boolean
  keyboard?: boolean
  baseColor?: string
  onEngine?: MovementHanlder
  onRudder?: MovementHanlder
}

const RobotJoystick = ({
  move,
  stop,
  start,
  vertical,
  keyboard = false,
  baseColor = 'rgba(255, 255, 255, 0.40)',
  onEngine = () => {},
  onRudder = () => {},
}: Props) => {
  const [pos, setPos] = useState<number | null>(null)
  const { x, y } = useMoveKeyboardJoystick({
    enabled: keyboard,
    movementHanlders: {
      onEngine,
      onRudder,
    },
  })

  function setMove(event: IJoystickUpdateEvent) {
    vertical ? setPos(event.x) : setPos(event.y)
  }

  const handleMove = (event: IJoystickUpdateEvent) => {
    setMove(event)
    if (move) {
      move(event)
    }
  }
  const handleStop = (event: IJoystickUpdateEvent) => {
    setMove(event)
    if (stop) {
      stop(event)
    }
  }

  return (
    <Box className={style.joystickWrapper}>
      <Joystick
        size={152}
        stickSize={50}
        baseColor={baseColor}
        stickColor="#424040"
        move={handleMove}
        stop={handleStop}
        start={start}
        disabled={keyboard}
        pos={keyboard && (x || y) ? { x, y } : undefined}
      ></Joystick>

      <Box className={clsx(style.joystickBackground, { [style.vertical]: vertical })}>
        <JoysticDirection
          className={clsx(style.joystickDirection, style.up, { [style.white]: pos !== null && pos > 0 })}
        />
        <JoysticDirection
          className={clsx(style.joystickDirection, style.down, { [style.white]: pos !== null && pos < 0 })}
        />
      </Box>
    </Box>
  )
}

export default RobotJoystick
